import { useCallback, useMemo } from 'react';

import map from 'lodash/map';

import {
  useDepartmentsGet,
  useProLaborLevelDesignations,
} from '@sbv-clients/data-access-api';
import { Select, useTransformSelectValue } from '@sbv-clients/ui-shared';

import { useAppendAllOption } from './util';
import useAutoSelectValue from './util/use-auto-select-value';

export function DepartmentFilter({
  withAllOption = false,
  autoSelectIfEmpty = false,
  useContextFn,
  onChange: callback,
  errorMessages = {},
  filteredByOpeningTemplates = true,
}: {
  withAllOption?: boolean;
  autoSelectIfEmpty?: boolean;
  onChange?: (value: number) => void;
  useContextFn: () => {
    facilityId?: number;
    departmentId?: number;
    setDepartmentId: (value: number) => void;
    onEmployeeIdChange?: (value: number) => void;
  };
  filteredByOpeningTemplates?: boolean;
  errorMessages?: Record<string, string>;
}) {
  const {
    facilityId,
    departmentId: value,
    setDepartmentId: onChange,
  } = useContextFn();

  const { data, isLoading, isSuccess } = useDepartmentsGet({
    facilityId,
    filteredByOpeningTemplates: filteredByOpeningTemplates,
  });

  const { DepartmentLaborLevel } = useProLaborLevelDesignations();

  const options = useMemo(
    () =>
      map(data, (item) => ({
        id: item.departmentId,
        label: item.name ?? '',
        value: item.departmentId,
      })),
    [data]
  );

  useAppendAllOption(options, withAllOption);

  const sharedOnChangeHandler = useCallback(
    (value: number) => {
      onChange(value);
      callback?.(value);
    },
    [callback, onChange]
  );
  useAutoSelectValue({
    value,
    options,
    selectFirstAsDefault: autoSelectIfEmpty,
    callback: onChange,
    isSuccess,
  });
  const handleChange = useTransformSelectValue<number>(sharedOnChangeHandler);
  const helperText = errorMessages['departmentId'];
  return (
    <Select
      disabled={isLoading}
      fullWidth
      size="small"
      isLoading={isLoading}
      value={value}
      label={DepartmentLaborLevel}
      options={options}
      onChange={handleChange}
      error={!!helperText}
      helperText={helperText}
    />
  );
}
